import {
  Box,
  Flex,
  Image,
  rem,
  useMantineColorScheme,
  useMantineTheme,
} from "@mantine/core";
import { getTextLogo } from "@/shared/utils";
import { useMobileScreen } from "@/shared/hooks/useMobileScreen";

type AccountFlowLayoutProps = {
  children?: React.ReactNode;
  showLogo?: boolean;
};

const AccountFlowLayout = ({
  children,
  showLogo = true,
}: AccountFlowLayoutProps) => {
  const theme = useMantineTheme();
  const { colorScheme } = useMantineColorScheme();

  const logo = getTextLogo(colorScheme);
  const { isMobileScreen } = useMobileScreen();

  const background =
    colorScheme === "dark"
      ? `linear-gradient(117deg, ${theme.colors["background_3"][0]} 4.48%, ${theme.colors["P900"][0]} 94.25%)`
      : theme.colors["background_3"][0];

  return (
    <Box
      style={{ background, minHeight: "100vh" }}
      p={isMobileScreen ? `${rem(24)} ${rem(12)}` : `${rem(32)} ${rem(12)}`}>
      <Flex
        direction="column"
        align="center">
        <Flex
          direction="column"
          align="center"
          maw={rem(640)}
          w="100%"
          style={{ flexGrow: 1 }}>
          {showLogo && (
            <Image
              radius="md"
              src={logo}
              w={isMobileScreen ? rem(160) : rem(220)}
              alt="Logo do Super Agents"
              my={isMobileScreen ? rem(20) : rem(36)}
            />
          )}
          {children}
        </Flex>
      </Flex>
    </Box>
  );
};

export default AccountFlowLayout;
